
define('models/Physician',[
	'core/can',
	'models/Base',
	'bloodhound'
], function(can, Base, Bloodhound /*, faker */) {

	// Initialize the Bloodhound suggestion engine
	var engine = new Bloodhound({
	    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('Npi', 'LastName', 'FirstName'),
	    queryTokenizer: Bloodhound.tokenizers.whitespace,
	    remote: '/Codes/NPI/Search?pageSize=10&query=%QUERY'
	});
	var promise = engine.initialize();

	// ObjId
	// Npi
	// ProviderType
	// IdentifierQualifier
	// Identifier
	// Address
	// Name
	// DOB
	// Gender
	
	return Base.extend({
	
		// findOne: 'GET /Codes/NPI/{type}/{id}',
		
		search: engine.ttAdapter()
		
		// TODO Verify...
	
	},{
		
		define: {
			Name: {
				value: {}
			}
		},
		
		_Name: can.compute(function() {
			if (typeof this.attr('Name') === 'string') {
				return this.attr('Name');
			} else {
				if (this.attr('Name.First') && this.attr('Name.Last')) {
					return this.attr('Name.Last') + ', ' + this.attr('Name.First');
				} else {
					return this.attr('Name.First') || this.attr('Name.Last') || '';
				}
				
			}
		}),
		
		_ProviderType: can.compute(function() {
			switch (this.attr('ProviderType')) {
				case 0: return 'Billing';
				case 1: return 'PayTo';
				case 2: return 'ServiceFacility';
				case 3: return 'Attending';
				case 4: return 'Referring';
				case 5: return 'Operating';
				case 6: return 'Renderring';
				case 7: return 'Other1';
				case 8: return 'Other2';
			}
		}),
		
		_Gender: can.compute(function() {
			switch (this.attr('Gender')) {
				case 0: return 'Male';
				case 1: return 'Female';
				default:
				case 2: return 'Unknown';
			}
		})
	});
	
});
